<template>
  <!-- 规则设置 -->
  <div class="ruleSet">
    <!-- 左侧-目录 -->
    <div class="leftSlider">
      <ruleLeft @setCurrentRule="setCurrentRule"></ruleLeft>
    </div>

    <!-- 右侧-表格展示 -->
    <div class="rightSlider">
      <ruleRight ref="ruleSetRight"></ruleRight>
    </div>
  </div>
</template>

<script>
import ruleLeft from "./ruleSetComponent/ruleLeft.vue";
import ruleRight from "./ruleSetComponent/ruleRight copy.vue";

export default {
  name: "RuleSet",
  components: { ruleLeft, ruleRight },
  data() {
    return { prevRuleId: "" };
  },
  beforeDestroy() {
    clearInterval(this._timer);
  },
  methods: {
    // 左侧设置rule，传给右侧
    setCurrentRule(rule) {
      console.log(rule);
      if (this.prevRuleId !== rule.ruleId) {
        this.prevRuleId = rule.ruleId;
        if (Object.keys(this.$refs.ruleSetRight.layoutAttrList).length && this.$refs.ruleSetRight.professionalList.length) {
          this.$refs.ruleSetRight.getRevitSettingsList(this.prevRuleId);
        } else {
          this._timer = setInterval(() => {
            if (Object.keys(this.$refs.ruleSetRight.layoutAttrList).length && this.$refs.ruleSetRight.professionalList.length) {
              clearInterval(this._timer);
              this.$refs.ruleSetRight.getRevitSettingsList(this.prevRuleId);
            }
          }, 100);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ruleSet {
  width: 100%;
  height: 100%;
  background-color: #ffffff;

  display: flex;

  .leftSlider {
    width: 150px;
    height: 100%;
    border-right: 1px solid #e5e8f1;
  }

  .rightSlider {
    width: calc(100% - 150px);
    height: 100%;
  }
}
</style>
